export interface ChangeInfoTrackingModel {
	name: string;
	location?: ChangeInfoLocation;
}

enum ChangeInfoLocation {
	Email = "change email",
	AddressSearch = "change address search",
	AddressDetails = "change address details"
}

export const CHANGE_EMAIL_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Email Viewed"
};

export const CHANGE_EMAIL_BUTTON: ChangeInfoTrackingModel = {
	name: "Change Email Continue Button Clicked"
};

export const CHANGE_EMAIL_2FA_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Email 2FA Viewed"
};

export const CHANGE_EMAIL_SMS_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Email SMS Viewed"
};

export const CHANGE_EMAIL_CONFIRMATION_EMAIL: ChangeInfoTrackingModel = {
	name: "Change Email Confirmation Link Sent Viewed"
};

export const CHANGE_EMAIL_SUCCESS: ChangeInfoTrackingModel = {
	name: "Change Email Success Notification Viewed"
};

export const CHANGE_ADDRESS_SEARCH_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Address Search Viewed"
};

export const CHANGE_ADDRESS_DETAILS_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Address Details Viewed"
};

export const CHANGE_ADDRESS_BUTTON: ChangeInfoTrackingModel = {
	name: "Change Address Continue Button Clicked"
};

export const CHANGE_ADDRESS_COUNTRY_NOTIFICATION_SEARCH: ChangeInfoTrackingModel = {
	name: "Change Address Country Notification Viewed",
	location: ChangeInfoLocation.AddressSearch
};

export const CHANGE_ADDRESS_COUNTRY_NOTIFICATION_DETAILS: ChangeInfoTrackingModel = {
	name: "Change Address Country Notification Viewed",
	location: ChangeInfoLocation.AddressDetails
};

export const CHANGE_ADDRESS_2FA_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Address 2FA Viewed"
};

export const CHANGE_ADDRESS_SMS_VIEWED: ChangeInfoTrackingModel = {
	name: "Change Address SMS Viewed"
};

export const CHANGE_ADDRESS_SUCCESS: ChangeInfoTrackingModel = {
	name: "Change Address Success Notification Viewed"
};
